import React, { useEffect } from "react";
import { useStore } from "zustand";
import { InputText } from "../index";
import { useAppStateStore, useLeadStore } from "../../../../stores";
import { validateName } from "../../../../utilities";
import validationProps from "./validationProps";

const handleOnFirstNameChange = (event) => {
  useLeadStore.set({
    consumer: {
      ...useLeadStore.get("consumer"),
      firstname: event.target.value,
    },
  });
};

const handleOnLastNameChange = (event) => {
  useLeadStore.set({
    consumer: {
      ...useLeadStore.get("consumer"),
      lastname: event.target.value,
    },
  });
};

const validateFirstName = () => {
  const { firstname } = validationProps("firstname");
  useAppStateStore.setValidity("aboutYou", {
    firstName: validateName(firstname),
  });
};

const validateLastName = () => {
  const { lastname } = validationProps("lastname");
  useAppStateStore.setValidity("aboutYou", {
    lastName: validateName(lastname),
  });
};

const InputFirstName = () => {
  const appState = useStore(useAppStateStore);
  const lead = useStore(useLeadStore);

  useEffect(() => {
    validateFirstName();
  }, [lead.consumer.firstname]);

  return (
    <InputText
      id="first-name"
      dataTestId="first-name"
      label="First Name"
      errorText="Please enter your first name"
      onChange={handleOnFirstNameChange}
      value={lead.consumer.firstname}
      hasError={appState.formSubmitted && !appState.isValid.aboutYou.firstName}
      autoComplete="given-name"
      displayRequirementIndicator={true}
    />
  );
};

const InputLastName = () => {
  const appState = useStore(useAppStateStore);
  const lead = useStore(useLeadStore);

  useEffect(() => {
    validateLastName();
  }, [lead.consumer.lastname]);

  return (
    <InputText
      id="last-name"
      dataTestId="last-name"
      label="Last Name"
      errorText="Please enter your last name"
      onChange={handleOnLastNameChange}
      value={lead.consumer.lastname}
      hasError={appState.formSubmitted && !appState.isValid.aboutYou.lastName}
      autoComplete="family-name"
      displayRequirementIndicator={true}
    />
  );
};

const InfoName = () => {
  return (
    <div className="row">
      <InputFirstName />
      <InputLastName />
    </div>
  );
};

export default InfoName;
export { InputFirstName, InputLastName };
